// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label[data-v-0e7a2ebc]{color:rgba(0,0,0,.87)}", ""]);
// Exports
module.exports = exports;
